import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../components/Layout/Page';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import Request from '../../../requests/api/performance_cycles';
import PerformanceCycleEditForm from './PerformanceCycleEditForm';
import Header from './Header';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function PerformanceCycleEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [performanceCycle, setPerformanceCycle] = useState();

  useEffect(() => {
    const getPerformanceCycle = async () => {
      const response = await Request.getPerformanceCycleById(props.match.params.id);
      if (isMountedRef.current) {
        setPerformanceCycle(response.data.data.performanceCycle);
      }
    };

    getPerformanceCycle();
    // eslint-disable-next-line
  }, [props]);

  if (!performanceCycle) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="TubeOps | Editar Ciclo de Performance"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <PerformanceCycleEditForm performanceCycle={performanceCycle} />
        </Box>
      </Container>
    </Page>
  );
}

PerformanceCycleEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(PerformanceCycleEditView);
